import React from 'react';
import { observer } from 'mobx-react-lite';
import { Grid } from '@material-ui/core';
import { BooleanInput } from '../../store/inputs/BooleanInput';

const CBooleanInput = observer(({ item }: { item: BooleanInput }) => {
  const {
    label,
    value,
    onChange,
    disabled,
    isKey,
    isEdit,
  } = item;

  const isLocked = disabled || (isKey && isEdit);
  const isNull = value === null;
  const isChecked = value === true;

  return (
    <Grid container spacing={3}>
      <Grid item xs={11} style={{ margin: '0 auto' }}>
        <div
          style={{
            border: '1px solid #e0e0e0',
            borderRadius: '10px',
            padding: '12px 16px',
            margin: '8px 0',
            background: isLocked ? '#fafafa' : '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <i
              className={isKey ? 'bx bx-key' : 'bx bx-toggle-left'}
              style={{ fontSize: '15px', color: '#757575' }}
            />
            <span style={{ fontSize: '12px', fontWeight: 500, color: '#757575', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
              {label}
            </span>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {/* Null toggle */}
            {!isLocked && (
              <button
                onClick={() => onChange(isNull ? false : null)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '28px',
                  height: '28px',
                  border: '1px solid #e0e0e0',
                  borderRadius: '6px',
                  background: isNull ? '#fff3e0' : '#fafafa',
                  cursor: 'pointer',
                  outline: 'none',
                  transition: 'all 0.15s ease',
                }}
                title={isNull ? 'Enable field' : 'Set to null'}
              >
                <i
                  className={isNull ? 'bx bx-minus' : 'bx bx-block'}
                  style={{ fontSize: '14px', color: isNull ? '#f57c00' : '#bdbdbd' }}
                />
              </button>
            )}

            {/* Toggle switch */}
            <button
              onClick={() => !isLocked && !isNull && onChange(!isChecked)}
              disabled={isLocked || isNull}
              style={{
                position: 'relative',
                width: '44px',
                height: '24px',
                borderRadius: '12px',
                border: '1px solid #e0e0e0',
                background: isNull ? '#eeeeee' : isChecked ? '#66bb6a' : '#e0e0e0',
                cursor: isLocked || isNull ? 'default' : 'pointer',
                outline: 'none',
                transition: 'background 0.2s ease',
                padding: 0,
                flexShrink: 0,
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '2px',
                  left: isChecked ? '22px' : '2px',
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  background: '#fff',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
                  transition: 'left 0.2s ease',
                }}
              />
            </button>

            <span style={{ fontSize: '12px', color: isNull ? '#bdbdbd' : '#616161', minWidth: '28px' }}>
              {isNull ? '—' : isChecked ? 'Yes' : 'No'}
            </span>
          </div>
        </div>
      </Grid>
    </Grid>
  );
});

export default CBooleanInput;
